module.exports = new __parcel__URL__("Charlie_Text-Thin_Italic.dd27b1a6.woff2").toString();